import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../App.css';

function Misc() {
  const { t } = useTranslation();

  return (
    <section id="misc" style={{ padding: 'var(--section-spacing) 0' }}>
      <Container>
        <h2 className="section-title">{t('extracurriculars')}</h2>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="glass-card">
              <Row className="align-items-center">
                <Col md={6} className="mb-4 mb-md-0">
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    marginBottom: '1rem'
                  }}>
                    <img src="midea_iot.jpg" alt="midea logo" width="60" className="rounded" />
                    <h3 style={{ fontSize: '1.5rem', margin: 0 }}>Midea IOT Hackathon</h3>
                  </div>
                  <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
                    {t('midea_desc')}
                  </p>
                  <a href="https://miot.qyr.pub" target="_blank" rel="noreferrer" style={{
                    color: 'var(--accent-primary)',
                    fontWeight: '600',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '5px'
                  }}>
                    {t('learn_more_btn')} <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </Col>
                <Col md={6}>
                  <img
                    src="midea_shot.jpg"
                    alt="Project screenshot"
                    className="img-fluid rounded"
                    style={{ border: '1px solid var(--glass-border)' }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Misc;
